import { Injectable } from '@angular/core';
import { SettingsInitializer } from './settings.initializer';

/**
 * A service that stores settings for the application and the user
 */
@Injectable({
  providedIn: 'root'
})
export class SettingsService {

  settings: any = {};

  constructor(private settingsInitializer: SettingsInitializer) {
    const data = settingsInitializer.get();
    for (const [key, value] of Object.entries(data)) {
      this.defaults(key, value);
    }

    (window as any).NG_SHARED_SETTINGS_SERVICE = this;
  }

  exists(key ?: string): boolean {
    return this.dotObject(this.settings, key, undefined) !== undefined;
  }

  get(key: string, defaultValue?: any): any {
    return this.dotObject(this.settings, key, defaultValue);
  }

  put(key: string, value: any) {
    let currentObj = this.settings;

    const dots = key.split('.');

    for (let i = 0; i < dots.length; i++) {
      const itemName = dots[i];

      // If we are on the last dot
      if (i === dots.length - 1) {
        currentObj[itemName] = value;
      } else {
        if (!currentObj.hasOwnProperty(itemName)) {
          currentObj[itemName] = {};
        } else if (typeof currentObj[itemName] !== 'object') {
          throw new Error('Can not add sub property to non object [' + typeof currentObj[itemName] + ']');
        }
      }

      currentObj = currentObj[itemName];
    }
  }

  defaults(name: string, objectToMerge: any) {
    if (typeof objectToMerge === "object") {
      this.put(name, {...objectToMerge, ...this.get(name, {})});
    } else {
      this.put(name, objectToMerge);
    }
  }

  private dotObject(startObj: any, dotString: string, defaultValue?: any) {
    if (!dotString) {
      return defaultValue;
    }

    let currentObj = startObj;

    const dots = dotString.split('.');
    for (let i = 0; i < dots.length; i++) {
      if (currentObj == null || currentObj.hasOwnProperty(dots[i]) === false) {
        return defaultValue;
      }

      currentObj = currentObj[dots[i]];
    }

    return currentObj;
  }
}
